import { render, staticRenderFns } from "./SellersSellsTable.vue?vue&type=template&id=2f391e2c&"
import script from "./SellersSellsTable.vue?vue&type=script&lang=js&"
export * from "./SellersSellsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports